import axios from 'axios';
const client = axios.create();
/*
  글로벌 설정 예시:
  
  // API 주소를 다른 곳으로 사용함
  client.defaults.baseURL = 'https://external-api-server.com/' 

  // 헤더 설정
  client.defaults.headers.common['Authorization'] = 'Bearer a1b2c3d4';

  // 인터셉터 설정
  axios.intercepter.response.use(
    response => {
      // 요청 성공 시 특정 작업 수행
      return response;
    }, 
    error => {
      // 요청 실패 시 특정 작업 수행
      return Promise.reject(error);
    }
  })  
*/

client.interceptors.request.use(function (config) {
    const adminToken = localStorage.getItem('adminToken');
    if(adminToken !== null) client.defaults.headers.common['Authorization'] = 'Bearer '+adminToken;
    return config;
}, function (error) {
    // 요청 오류가 있는 작업 수행
    return Promise.reject(error);
});

// 인터셉터 설정
client.interceptors.response.use(
  function (response) {
    // Do something with response data
    const { data } = response;
    if (typeof data.success !== 'undefined') {
      const { success, message } = data;
      if (success === false) {
        throw new Error(message);
      }
    }
    return response;
  },
  function ({ response }) {
    // Do something with response error
    const { status, data, statusText } = response;
    if ([401].indexOf(status) !== -1) {
      // 권한 인증 안된경우
      // 로그인 없이 접속하는 페이지는 이곳에 예외처리 해주어야함.
      if (
        window.location.pathname !== '/login' &&
        window.location.pathname !== '/findPassword' &&
        window.location.pathname !== '/join'
      ) {
        localStorage.clear();
        window.location.replace('/login');
      }
    }
    const error = (data && data.message) || statusText;
    return Promise.reject(error);
  }
);

export default client;
